export default {
    onUpdate: registration => {
        if(registration) {
            registration.unregister().then(() => {
                window.location.reload()
            })
        }
    },
}